import { Typography } from 'antd'

const { Title } = Typography

export default function FAQs() {
  return <>
    <Title level={2}>Frequently Asked Questions</Title>
    <p>Please look here to see some answers to the questions we most want to answer.</p>
  </>
}